import { Page } from 'components/layout/panel/Page/Page';
import { ReportChildrenListContainer } from 'components/schoolObligation/ReportDetails/ReportChildrenList/ReportChildrenListContainer';
import { ReportOverviewContainer } from 'components/schoolObligation/ReportDetails/ReportOverview/ReportOverviewContainer';
import { ReportsDetailsContainer } from 'components/schoolObligation/ReportDetails/ReportsDetailsContainer';
import { useTranslator } from 'components/shared/hooks';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import { Box } from 'components/shared/surfaces/Box/Box';
import {
  ROUTE_SCHOOL_OBLIGATION_REPORT_DETAILS,
  ROUTE_SCHOOL_OBLIGATION_REPORT_DETAILS_OVERVIEW,
  ROUTE_SCHOOL_OBLIGATION_REPORT_DETAILS_CHILDREN_LIST,
  ROUTE_SCHOOL_OBLIGATION_REPORTS,
} from 'config/routes';
import { push } from 'utils/navigation/navigate';
import React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { NotFoundView } from 'views/Errors/NotFound.view';
import { makePath } from 'utils/navigation/makePath';
import { relativePath } from 'utils/navigation/relativePath';

export const ReportDetailsView: React.FC = () => {
  const trans = useTranslator();
  const { id: reportId } = useParams<{ id: string }>();
  const handleBack = () => push(ROUTE_SCHOOL_OBLIGATION_REPORTS);

  return (
    <>
      <Breadcrumb label={trans('BREADCRUMB.SCHOOL_OBLIGATION.REPORTS')} to={ROUTE_SCHOOL_OBLIGATION_REPORTS} />

      <Page title={trans('SCHOOL_OBLIGATION.REPORT.TITLE')}>
        <Box margin={[0, 2, 2]} grow>
          <ReportsDetailsContainer reportId={reportId} onBack={handleBack}>
            <Routes>
              <Route
                path={relativePath(ROUTE_SCHOOL_OBLIGATION_REPORT_DETAILS, ROUTE_SCHOOL_OBLIGATION_REPORT_DETAILS)}
                element={
                  <Navigate
                    to={makePath(ROUTE_SCHOOL_OBLIGATION_REPORT_DETAILS_OVERVIEW, { id: reportId })}
                    replace
                  />
                }
              />
              <Route
                path={relativePath(
                  ROUTE_SCHOOL_OBLIGATION_REPORT_DETAILS_OVERVIEW,
                  ROUTE_SCHOOL_OBLIGATION_REPORT_DETAILS,
                )}
                element={
                  <>
                    <Breadcrumb label={trans('BREADCRUMB.SCHOOL_OBLIGATION.REPORT_DETAILS')} static />
                    <ReportOverviewContainer />
                  </>
                }
              />
              <Route
                path={relativePath(
                  ROUTE_SCHOOL_OBLIGATION_REPORT_DETAILS_CHILDREN_LIST,
                  ROUTE_SCHOOL_OBLIGATION_REPORT_DETAILS,
                )}
                element={
                  <>
                    <Breadcrumb label={trans('BREADCRUMB.SCHOOL_OBLIGATION.REPORT_DETAILS')} static />
                    <ReportChildrenListContainer />
                  </>
                }
              />
              <Route path="*" element={<NotFoundView />} />
            </Routes>
          </ReportsDetailsContainer>
        </Box>
      </Page>
    </>
  );
};
